import React from 'react';
import { Button, Col, Divider, Row, Typography } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { CheckCircleFilled, CheckCircleOutlined } from '@ant-design/icons';
import colors from '~/constants/colors';
import { useIsMobile } from '~/hooks/useScreenSizes';

function BankDetails(props: any) {
  const { data = {} } = props;
  const { t } = useTranslation('ksaApplication');
  function maskExceptLast3(str: any) {
    if (str?.length <= 3) {
      return str;
    }
    const maskChar = 'X';
    const keep = str?.slice(-3);
    const maskedPart = maskChar?.repeat(str?.length - 3);
    return `${maskedPart}${keep}`;
  }
  const isMobile = useIsMobile();
  return (
    <div style={{ marginTop: 24 }}>
      <Typography.Title style={{ marginBottom: 15 }} level={4}>
        {t('Bank Details')}
      </Typography.Title>
      <Box isMobile={isMobile}>
        {data?.bankAccount?.accountHolderName && (
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Typography.Paragraph className="labelKey">
                {t('Account Holder Name')}
              </Typography.Paragraph>
              <Typography.Paragraph className="value">
                {data?.bankAccount?.accountHolderName?.replace(
                  /(.{2})(.{4})/g,
                  // eslint-disable-next-line
                  (match: any, visible: any, hidden: any) => visible + hidden?.replace(/./g, '*')
                )}
              </Typography.Paragraph>
            </Col>
            <Col span={12}>
              <Typography.Paragraph className="labelKey">{t('Bank Name')}</Typography.Paragraph>
              <Typography.Paragraph className="value">
                {data?.bankAccount?.bankName}
              </Typography.Paragraph>
            </Col>
          </Row>
        )}
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <div style={{ display: 'flex', gap: 8 }}>
              {!!data?.bankAccount?.files?.length && (
                <CheckCircleFilled
                  style={{
                    color: '#CDF0DD',
                    fontSize: 20,
                    display: 'inline-flex',
                    alignItems: 'center',
                    verticalAlign: 'middle',
                  }}
                />
              )}
              <Typography.Paragraph
                className="labelKey"
                style={{
                  margin: 0,
                  lineHeight: '20px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  verticalAlign: 'middle',
                }}
              >
                {t('IBAN Number')}
              </Typography.Paragraph>
            </div>

            <Typography.Paragraph className="value">
              {maskExceptLast3(data?.bankAccount?.iban)}
            </Typography.Paragraph>
          </Col>
        </Row>
      </Box>
    </div>
  );
}

const Box = styled.div<any>`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
  background-color: ${({ isMobile }) => (isMobile ? '#ffffff' : '#F9F9F9')};
  padding: 20px 16px;
  border-radius: 8px;
  border: 1px solid #F5F5F5;
  box-shadow: 0 2px 6px 0 rgba(0, 89, 150, 0.03), 0 -1px 8px -10px rgba(0, 89, 150, 0.03);

  .labelKey {
    color: #000;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    line-height: 14px;
    letter-spacing: 0.14px;
    //margin-bottom: 12px;
  }

  .value {
    color: #000;
    font-family: Inter, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 14px;
    margin-top: 8px;
  }
`;
export default BankDetails;
